import { IErrorModal } from 'components/Modals/ErrorModal'
import Translation from 'components/Translation'
import React, { useState } from 'react'
import { classNames } from 'utils/dom-helpers'
import GenericDialog from './GenericDialog'

const GenericError: React.FC<IErrorModal> = ({
    error_message,
    onCloseModal,
    type,
    tag,
}) => {
    const [showMore, setShowMore] = useState(true)
    const toggleReadMore = () => setShowMore((prev) => !prev)
    const handleErrorMessage = (text: string) => {
        return (
            <span className="text whitespace-wrap break-words">
                {showMore ? text.slice(0, 15) : text}
                <span
                    onClick={toggleReadMore}
                    className="text-sky-500 cursor-pointer"
                >
                    {showMore ? '...read more' : ' show less'}
                </span>
            </span>
        )
    }

    const content: JSX.Element = (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
            }}
        >
            <i
                className={classNames(
                    ' text-xl  text-white rounded-full flex justify-center items-center mb-4 w-16 h-16 pb-2',
                    type === 'success'
                        ? 'feather-check-circle bg-green-500'
                        : 'feather-alert-triangle bg-red-500 text-4xl'
                )}
            />
            <div className="my-9">
                <h1 className="text-3xl font-semibold text-center text-primary">
                    {tag && tag.length > 0 ? (
                        <Translation content_key={tag} />
                    ) : (
                        'Oops! An error has occurred with your request'
                    )}
                </h1>
            </div>
            <div>
                <h2 className="text-center text-slate-400 text-lg">
                    You may visit the{' '}
                    <a
                        className="text-primary font-semibold cursor-pointer"
                        href="http://help.aot.plus"
                        target={'_blank'}
                        rel="noreferrer"
                    >
                        AOT Help Center
                    </a>{' '}
                    for more information or to contact support
                </h2>
            </div>
            <div className="flex justify-center w-4/5 my-5">
                <div className="h-1 text-black border-b-2 border-gray-200 w-full"></div>
            </div>
            {error_message && error_message.length ? (
                <div className="my-6 px-10 text-center text-md max-w-md">
                    <p>
                        Error Message: {handleErrorMessage(error_message)}
                    </p>
                </div>
            ) : (
                <></>
            )}
        </div>
    )
    return (
        <GenericDialog
            prompt_message={content}
            onCloseModal={onCloseModal}
            button_position="center"
        />
    )
}

export default GenericError
